import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';

import CreateBackflowJobGroupModal from '../components/CreateBackflowJobGroupModal';
import DataTable from '../../../sharedModules/dataTable';
import BackflowJobsFilter from '../components/BackflowJobsFilter';
import PageHeader from '../../../sharedModules/layout/PageHeader';
import PlumbingIcon from '@mui/icons-material/Plumbing';

import { backflowJobGroupsColumns } from '../constants/backflowListColumns';
import { useBackflowJobGroups, defaultBackflowJobGroupFilters } from '../hooks/useBackflowJobGroups';

const BackflowJobGroupsListPage: React.FunctionComponent = () => {
  const history = useHistory();

  const [createJobGroupModalOpen, setCreateJobGroupModalOpen] = useState<boolean>(false);
  const [filterValues, setFilterValues] = useState<any>(defaultBackflowJobGroupFilters);

  const { data, refetch } = useBackflowJobGroups(filterValues);
  const backflowJobGroups = data?.data?.result ?? [];

  const conditionalRowStyles = [
    {
      when: (row) => row.status?.toLowerCase() === 'overdue' || row.status?.toLowerCase() === 'closed no log',
      style: {
        backgroundColor: 'rgba(242, 38, 19, 0.9)',
        color: 'white',
        '&:hover': {
          cursor: 'not-allowed',
        },
      },
    },
  ];

  const columns = backflowJobGroupsColumns().filter(
    (col: any) => !['Completed', 'Water Authority', 'Authority-Provided Fields'].includes(col.name),
  );

  return (
    <Grid container>
      <CreateBackflowJobGroupModal
        fetchBackflowJobGroups={refetch}
        createJobGroupModalOpen={createJobGroupModalOpen}
        setCreateJobGroupModalOpen={setCreateJobGroupModalOpen}
      />
      <Grid item xs={12}>
        <PageHeader
          titleIcon={<PlumbingIcon />}
          mainTitle="Upcoming Tests"
          button={
            <Button variant="contained" color="primary" onClick={() => setCreateJobGroupModalOpen(true)}>
              Import Work Order
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 20, marginBottom: 20 }}>
        <BackflowJobsFilter
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          onFilter={(filterVals) => setFilterValues(filterVals)}
        />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <DataTable
              title=""
              columns={columns}
              data={backflowJobGroups}
              onRowClicked={(row: any) => history.push(`/backflow_tests/backflow_job_groups/${row.id}`)}
              conditionalRowStyles={conditionalRowStyles}
              dense
              highlightOnHover
              pointerOnHover
              pagination
              paginationPerPage={25}
              paginationRowsPerPageOptions={[25, 50, 100]}
              noHeader
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BackflowJobGroupsListPage;
